// Common parameters using in API

/** API endpoint URL */
let apiEndpoint = process.env.VUE_APP_API_ENDPOINT;

/** User token */
export const token = new URLSearchParams(window.location.search).get("token");

/**
 * Return current API endpoint
 */
export const getAPI = () => {
  return apiEndpoint;
};

/** Maximum edit file (aound or image) size in megabytes */
export const maxFileSize = Number(process.env.VUE_APP_MAX_FILE_SIZE);

/** Mangomolo endpoint to upload videos */
export const mangomoloUploadEndpoint = process.env.VUE_APP_UPLOAD_API_ENDPOINT;